module.exports = __webpack_public_path__ + "img/fayi_04.d678b349.jpg";